import styled from "styled-components";

export const Flag = styled.button`
  font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  line-height: 18px;
  letter-spacing: 0.05em;
  text-align: left;
  color: ${({ theme }) => theme.default.color.primary};
  text-transform: uppercase;
  border: 0;
  background: 0;
  align-items: center;
  display: flex;
  cursor: pointer;
`;
